import angular from 'angular'
import uiRouter from 'angular-ui-router'
import welcomeComponent from './welcome.component'

const welcomeModule = angular.module('welcome', [
        uiRouter
    ])

    .config(($stateProvider) => {
        'ngInject'

        $stateProvider
            .state('welcome', {
                url: '/',
                component: 'welcome'
            })
    })

    .component('welcome', welcomeComponent)

    .name

export default welcomeModule



// WEBPACK FOOTER //
// ./client/app/components/welcome/welcome.js